import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import FansSection from '../components/sections/Fans'; 

const FansPage = () => {
  return (
    <>
      <Header />
      <FansSection />
      <Footer />
    </>
  );
};

export default FansPage;
